jQuery( document ).ready(function() {
    // Check if component is added to the page
    if( jQuery('section.news-posts').length ) {

        let $ = jQuery;
        const $container = $(".js-news-wrapper");
        const $loadMoreBtn = $("#load-more-news");


        $loadMoreBtn.on("click", function () {
            loadResults();
        });



        function loadResults() {

            $currentPage = $container.attr('data-page');
            $postType = $container.attr('data-post_type');
            $perPage = $container.attr('data-posts_per_page');
            $exclude = $container.attr('data-exclude');
            $categories = $container.attr('data-categories');


            var sendData = {
                action: 'news_ajax_handler',
                page: $currentPage,
                postType: $postType,
                perPage: $perPage,
                exclude: $exclude,
                categories: $categories
            };

            $.ajax({
                url: ajaxadminurl.ajaxurl,
                type: 'GET',
                data: sendData,
                dataType: 'html',
                cache: false,
                timeout: 10000,
                beforeSend: function() {
                    $loadMoreBtn.hide();
                },
                error: function(xhr, ajaxOptions, thrownError) {
                    $loadMoreBtn.remove();
                },
                success: function(data, textStatus, jqXHR) {
                    var htmlData = $.parseHTML(jqXHR.responseText);
                    $container.append(htmlData);
                    $currentPage++;
                },
                complete: function(data) {
                    if (data.responseText !== '<div class="nothing-found"><h4>No results found</h3></div>') {
                        console.log($currentPage);
                        $container.attr('data-page', $currentPage);
                        checkNextPosts($currentPage);
                    }
                    AOS.init();
                }
            });
        }

        function checkNextPosts($page) {

            console.log($page);

            var sendData = {
                action: 'news_ajax_handler',
                page: $page,
                postType: $postType,
                perPage: $perPage,
                exclude: $exclude,
                categories: $categories
            };

            $.ajax({
                url: ajaxadminurl.ajaxurl,
                type: 'GET',
                data: sendData,
                dataType: 'html',
                cache: false,
                timeout: 10000,
                success: function(data, textStatus, jqXHR) {
                    if (data.responseText !== '<div class="nothing-found"><h4>No results found</h3></div>') {
                        $loadMoreBtn.show();
                    }
                },
                complete: function(data) {
                    if (data.responseText !== '<div class="nothing-found"><h4>No results found</h3></div>') {
                        $loadMoreBtn.show();
                    }
                }
            });
        }

    }
});